import React, { useState, useEffect } from "react";
import {
    Accordion,
    Alert, Button, Col, Row,
} from "react-bootstrap";
import { useSubheader } from "@metronic/layout";
import { HospitalData } from "@components/panels/hospital-data/hospital-data";
import { InssuredData } from "@components/panels/insured-data/inssured-data";
import { Documentation } from "@components/panels/documentation/documentation";
import { Binnacle } from "@components/panels/binnacle/binnacle";
import AuthLetters from "@components/panels/auth-letter/auth-letters";
import {
    getBySlug, update,
} from "@services/hospitalization";
import { getLastLetterMovByCase } from "@services/letter-movements";
import { MedicalFees } from "@components/panels/medical-fee/medical-fees";
import CaseHeader from "@components/panels/case-header/case-header";
import BlockCaseContext from "@contexts/block-case-context";
import { useCommentValidation } from "@contexts/comment-validation-context";
import WithCommentValidation from "@components/shared/with-comment-validation";
import { useAutomaticCommentSave } from "@hooks/use-automatic-comment-save";
import axios from "axios";
import moment from "moment/moment";
import {Redirect, useHistory} from "react-router-dom";
import {GetUser} from "@metronic/_helpers";
import {PROCEDURE_TYPES} from "@constants/procedure-types";
import {isCaseInCorrectModule} from "@utils/check-module-status";
import {CASE_STATUS} from "@constants/case-statuses";
import { getMexicoTimestamp } from "@utils/date-utils";

const CompletedCasesDetails = (props) => {
  const subheader = useSubheader();
  const { validateCommentRequired } = useCommentValidation();

    const { slug } = props.match.params;
    const { idUser } = GetUser().user;

    const [caseRecord, setCaseRecord] = useState({});
    const [, setLetterMov] = useState({});
    const [, setTotalLetters] = useState("0");
    const [shouldBlockCase, setShouldBlockCase] = useState(true);
    const [caseType, setCaseType] = useState("");
    const [note, setNote] = useState('');

    const { saveCommentAutomatically } = useAutomaticCommentSave({ caseData: caseRecord });
    const { saveCommentAutomaticallyUnam } = useAutomaticCommentSave({
        caseData: caseRecord,
        eventStage: null,
        comment: "FAVOR DE FACTURAR A UNAM, DE NO HACERLO NO SE PODRÁ PAGAR",
        isPageable: false,
        hideReason: true,
    });

    const history = useHistory();

    useEffect(() => {
        subheader.setTitle("Solicitudes Extemporáneas");
    }, [subheader]);

    useEffect(() => {
        getBySlug(slug).then((response) => {
            setCaseRecord(response.data);
            window.requires_tabulation = response.data.requiresTabulation;
            getLastLetterMovByCase(response.data.id).then((currentLetterMov) =>
                setLetterMov(currentLetterMov.data)
            );
        });
    }, [slug]);

    const onSubmitCaseType = async (e) => {
        e.preventDefault();

        if (caseType === '') {
            alert('El tipo de trámite es obligatorio');
            return;
        }

        update({ caseType }, caseRecord.id).then(async (response) =>{
            await saveCommentAutomatically();
            await saveCommentAutomaticallyUnam();
            alert("Actualizado");
        });

        setCaseRecord({ ...caseRecord, ...{ caseType } });
    }

    const onClickSendExtemporaneous = async () => {
        if (caseType === "") {
            alert("Debe actualizar el tipo de tramite");
            return;
        }

        if (!validateCommentRequired()) {
            return;
        }

        await saveCommentAutomatically();
        await saveCommentAutomaticallyUnam();

        let timestamp = getMexicoTimestamp();

        const dataUpdateCase =  {
            caseStatusId: 12,
            fecextemporaneous: timestamp,
            userId: idUser,
            caseType: caseType,
        };

        update(dataUpdateCase, caseRecord.id).then((response) => {
            history.push("/casos_finalizados_hospital");
        });

        setCaseRecord({ ...caseRecord, ...{ caseType } });
    }

    if (!isCaseInCorrectModule(caseRecord, [CASE_STATUS.FINISHED])) {
        return <Redirect to="/error/unauthorized"/>;
    }

    return (
        <>
            <Alert
                variant="success"
                className="text-center"
                style={{ fontSize: "16px" }}
            >
                Solicitudes Extemporáneas
            </Alert>

            <CaseHeader
                caseRecord={caseRecord}
                isSingleHeader={true}
                caseTypeSlot={
                    <>
                        <Row className="mt-2 align-items-center">
                            <Col className="col-auto pr-0">
                                <b>Tipo de TRÁMITE: *</b>
                            </Col>
                            <Col className="col-auto">
                                <select
                                    className="form-control"
                                    name="caseTypeSelect"
                                    value={caseType}
                                    onChange={e => {
                                        setCaseType(e.target.value);
                                        switch (e.target.value) {
                                            case PROCEDURE_TYPES.FEE_TABULATION:
                                                setNote('Especificar la Información del Médico Tratante a Tabular en el Apartado de Honorarios Medicos. Adjunta la Documentación Actualizada en caso de ser necesario.');
                                                break;
                                            case PROCEDURE_TYPES.VISA_VALIDATION_ATC:
                                                setNote('Especifica el Trámite solicitado en la Bitácora de Comentarios. Si necesitas un Nuevo Visado, por favor indica el Folio ATC.');
                                                break;
                                            case PROCEDURE_TYPES.AUTHORIZATION_LETTER_MODIFICATION:
                                                setNote('Especifica el Trámite solicitado en la Bitácora de Comentarios. Si necesitas un Nuevo Visado, por favor indica el Folio ATC.');
                                                break;
                                            default:
                                                setNote('');
                                                break;
                                        }
                                    }}
                                >
                                    <option value="">SELECCIONE UNA OPCIÓN....</option>
                                    <option value="Tabulación de Honorarios">
                                        Tabulación de Honorarios
                                    </option>
                                    <option value="Visado / Validación de ATC">
                                        Visado / Validación de ATC
                                    </option>
                                    <option value="Modificación Carta de Autorización">
                                        Modificación Carta de Autorización
                                    </option>
                                </select>
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col hidden={note === '' || note === null}>
                                <b>Nota: </b> {note}
                            </Col>
                        </Row>
                    </>
                }
            />

            <BlockCaseContext.Provider value={[shouldBlockCase, setShouldBlockCase]}>
                <Accordion defaultActiveKey="0" className="mt-5">
                    <Documentation
                        icon="fa-pencil-alt"
                        eventKey="4"
                        data={caseRecord}
                        {...props}
                    />
                    <MedicalFees
                        icon="fa-search"
                        eventKey="6"
                        data={caseRecord}
                        hideFormCreate={false}
                        ignoreStatus={true}
                        {...props}
                    />
                    <AuthLetters
                        icon="fa-search"
                        showForm={false}
                        hideDeleteOption={true}
                        eventKey="3"
                        data={caseRecord}
                        disabledAll={false}
                        setTotalLetters={setTotalLetters}
                        {...props}
                    />
                    <InssuredData
                        icon="fa-search"
                        eventKey="1"
                        data={caseRecord}
                        disabledAll={true}
                        bindSubmitForm={() => {
                        }}
                    />
                    <HospitalData
                        icon="fa-search"
                        eventKey="2"
                        data={caseRecord}
                        disabledAll={true}
                        bindSubmitForm={() => {
                        }}
                    />
                </Accordion>
                <Accordion defaultActiveKey="5" className="mt-5">
                    <Binnacle
                        icon="fa-search"
                        eventKey="5"
                        data={caseRecord}
                        eventStage="Casos Finalizados Hospital"
                        isDifferentBackground={true}
                        isPageable={true}
                        {...props}
                    />
                </Accordion>
            </BlockCaseContext.Provider>

            <Row>
                <Col className="mt-5">
                    <Button variant="danger" onClick={onClickSendExtemporaneous}>
                        Enviar a Dictamen Extemporáneos
                    </Button>
                </Col>
            </Row>
        </>
    );
};

export default WithCommentValidation(CompletedCasesDetails);

